export default "__VITE_ASSET__ffa33393__"